import { Box } from "@mui/material";
import { TaskType } from "~hooks/useTaskDashboard";

interface TaskTypeBadgeProps {
  type: TaskType;
}

export const TaskTypeBadge = ({ type }: TaskTypeBadgeProps) => {
  // Determine background color based on task type
  const getBackgroundColor = (taskType: TaskType) => {
    switch (taskType) {
      case "sales":
        return "primary.main";
      case "room":
        return "secondary.main";
      case "event":
        return "success.main";
      default:
        return "primary.main";
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: getBackgroundColor(type),
        color: "white",
        borderRadius: 1,
        px: 1,
        py: 0.5,
        fontSize: "0.75rem",
        fontWeight: "bold",
      }}
    >
      {type.toUpperCase()}
    </Box>
  );
};
